// extracted by mini-css-extract-plugin
export var chatHtmlText = "_pp-2";
export var chatLink = "_pp-0";
export var chatText = "_pp-1";